'use client'

import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Colors, Typography } from '@b-stock/fe-core/design-system'

import { SOLD_BY } from './content'
import { Inner, Section } from './ui'

const STATS = ['sellers', 'listings', 'retail', 'buyers'] as const

const Stats = styled.dl`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem 1.5rem;
  margin: 0;

  @media ${Breakpoints.min.large} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

const Value = styled.dd`
  ${Typography.Title1};
  order: -1;
  margin: 0;
  color: ${Colors.Semantic.BStock.default.lightBackground};
`

const Label = styled.dt`
  ${Typography.Body2};
  color: ${Colors.Semantic.Neutral.dark_grey};
`

const SoldBy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 2rem;
  border-top: 0.0625rem solid ${Colors.Semantic.Neutral.medium_grey};
`

const SoldByLabel = styled.p`
  ${Typography.Overline1};
  margin: 0;
  color: ${Colors.Semantic.Neutral.dark_grey};
  text-transform: uppercase;
  letter-spacing: 0.07rem;
`

const SoldByNames = styled.ul`
  ${Typography.Body2Semibold};
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 2rem;
  margin: 0;
  padding: 0;
  list-style: none;
  color: ${Colors.Semantic.Neutral.light_black};
`

export default function StatsBar() {
  return (
    <Section
      $background={Colors.Semantic.Neutral.light_grey}
      data-testid="logged-out-stats-bar"
    >
      <Inner>
        <Stats>
          {STATS.map((stat) => (
            <Stat key={stat}>
              <Label>
                <FormattedMessage
                  id={`LoggedOutHomepage.stats.${stat}.label`}
                />
              </Label>
              <Value>
                <FormattedMessage
                  id={`LoggedOutHomepage.stats.${stat}.value`}
                />
              </Value>
            </Stat>
          ))}
        </Stats>
        <SoldBy>
          <SoldByLabel>
            <FormattedMessage id="LoggedOutHomepage.stats.soldBy" />
          </SoldByLabel>
          <SoldByNames>
            {SOLD_BY.map((name) => (
              <li key={name}>{name}</li>
            ))}
          </SoldByNames>
        </SoldBy>
      </Inner>
    </Section>
  )
}
